import Footer from "../../footer"
import NavBar from "../../nav"

const StandardizedTraining = () => {
  return <div className='standardized-training'>
    <NavBar />
    <div>
    <section className="clean-block pfa-content clearfix">
			<div className="divider sections">
				<h1>Standardized Training Course</h1>
				<div className="headline-divider sections"></div>
				<h2>5 Core Training Modules</h2>
				<h3>High Level Training Summary</h3>
			</div>
		</section>
    <section className="clean-block show-checklists clearfix">
			<div className="container content-container highlights-container">	
				<div className="container-fluid">
					<div className="row">
						<div className="col-sm checklist-item">
							<div className="checklist-container clearfix">
								<div className="checklist-icon"><img className="checklist-icon" src="/assets/img/checklist.png" alt="" /></div>
								<div className="checklist-header">119 Training</div>
							</div>
							<div className="details">Learning the processes and procedures of being a 119 manager.</div>
						</div>
						<div className="col-sm checklist-item">
							<div className="checklist-container clearfix">
								<div className="checklist-icon"><img className="checklist-icon" src="/assets/img/checklist.png" alt="" /></div>
								<div className="checklist-header">SMS Training</div>
							</div>
							<div className="details">Risk Management approach to operations.</div>
						</div>
						<div className="col-sm checklist-item">
							<div className="checklist-container clearfix">
								<div className="checklist-icon"><img className="checklist-icon" src="/assets/img/checklist.png" alt="" /></div>
								<div className="checklist-header">135 Ground Training</div>
							</div>
							<div className="details">Operators using the Fly Compliant system will be trained to meet the latest standards.</div>
						</div>
						<div className="col-sm checklist-item">
							<div className="checklist-container clearfix">
								<div className="checklist-icon"><img className="checklist-icon" src="/assets/img/checklist.png" alt="" /></div>
								<div className="checklist-header">International Training</div>
							</div>
							<div className="details">A standardized approach to all operations with international differences.</div>
						</div>
						<div className="col-sm checklist-item">
							<div className="checklist-container clearfix">
								<div className="checklist-icon"><img className="checklist-icon" src="/assets/img/checklist.png" alt="" /></div>
								<div className="checklist-header">SOP Training</div>
							</div>
							<div className="details">Standardization is critical for crews to operate efficiently and safely.</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section className="clean-block clearfix">
			<div className="container content-container square-container standardized-training-container">		
				<div className="grid-1 callout">
					<div className="prose-header">119 Training Module</div>
					<div className="prose">This training is designed for part 119 managers and personnel that interface with the FAA. A benefit of this training is providing guidance on how to work efficiently with regulators and understanding regulations to maintain compliance.</div>
					<div className="prose-header prose-header-embedded">Training includes:</div>
					<div className="prose not-first">
						<ul>
							<li>Maintaining Compliance</li>
							<li>Interpreting Regulations</li>
							<li>Latest Guidance and Best Practices for managers.</li>
							<li>Record Keeping &amp; Manuals</li>
							<li className="last-bullet">OpSpecs Applications</li>
						</ul>
					</div>
				</div>	
				<div className="grid-2 callout">
					<div className="prose-header">SMS Training Module</div>
					<div className="prose">The SMS training enable SMS managers to understand the regulatory standards including EASA requirements. SMS training provides an understanding of the safety attributes and how to implement a Safety Management System. As part of the foundation of SMS the number of controls and processes within a SMS system to enable company personnel to complete risk mitigation and assessment.</div>
					<div className="prose-header prose-header-embedded">Training includes:</div>
					<div className="prose">
						<ul>
							<li>SMS Part 5 and EASA Standards</li>
							<li>SMS Policies and Procedures (Manuals)</li>
							<li>Root Cause Analysis &amp; Assessment</li>
							<li>Safety Performance Indicators and Targets</li>
							<li className="last-bullet">Risk Profile Register</li>
						</ul>
					</div>	
				</div>	
				<div className="grid-3 callout">
					<div className="prose-header">135 Ground Training Module</div>
					<div className="prose">Fly Compliant is providing a standardized method of completing required ground training, Operator Specific elements, including Basic Indoctrination and Recurrent Training. Operators using the Fly Compliant training program will benefit from this course with an in-depth review of the key regulatory requirements.</div>
					<div className="prose-header prose-header-embedded">Training include:</div>
					<div className="prose">
						<ul>
							<li>Aircraft Performance and Airport Analysis</li>
							<li>OpSpecs</li>
							<li>Duties and Responsibilities</li>
							<li>Company Manuals 135.23 Requirements</li>
							<li className="last-bullet">Applicable Regulatory Requirements 119 and 135</li>
						</ul>
					</div>	
				</div>	
				<div className="grid-4 callout">
					<div className="prose-header">International Training Module</div>
					<div className="prose">International Training provides pilots with the necessary knowledge and preparation to conduct safe operations using International Civil Aviation Organization (ICAO) and international
SOPs. The training focuses on the latest procedures associated with flying internationally.</div>
					<div className="prose-header prose-header-embedded">Training includes:</div>
					<div className="prose">
						<ul>
							<li>Trip planning</li>
							<li>Flight planning</li>
							<li>Navigation</li>
							<li>Enroute and terminal Procedures</li>
							<li className="last-bullet">Common errors</li>
						</ul>
					</div>	
					<div className="prose click-through"><a href="/training/international-training">View Class Details</a></div>					
				</div>	
				<div className="grid-5 callout full-grid-item">
					<div className="prose-header">SOP Training Module</div>
					<div className="prose">Standard Operating Procedures (SOPs) are the foundation to flying safely. By adherence to company SOPs operators will ensure efficiency and situation awareness. SOP training details the procedures for all flights (domestic and international). SOPs are the foundation for any size operation.</div>
					<div className="prose-header prose-header-embedded">Training includes:</div>
					<div className="prose">
						<ul>
							<li>Pilot Procedures</li>
							<li>Situational Awareness</li>
							<li>Aeronautical Decision Making</li>
							<li>SOPs During Non-Normal</li>
							<li className="last-bullet">Pilot Flying and Non-Flying Pilot Duties</li>
						</ul>
					</div>	
				</div>
			</div>		
		</section>
    </div>
    <Footer />
  </div>
}

export default StandardizedTraining